import { ILibTheme } from '../types';
import { AT_LIB_THEMES_LIST_ACTION_SET, ILibThemesListActionSetAction } from './types';

export const libThemesListActionSet = (
    list: ILibTheme[]
): ILibThemesListActionSetAction => ({
    type: AT_LIB_THEMES_LIST_ACTION_SET,
    list
});
